export class Data {
  constructor(
    dataType,
    adId,
    episodeId,
    startTimeMinutes,
    endTimeMinutes,
    event,
    state,
    podcastId,
    podcastFollowState,
    pageName,
    listName,
    buttonName
  ) {
    switch (dataType) {
      case 'streamedDuration':
        this.dataType = dataType
        this.episodeId = episodeId
        this.state = event
        this.startTimeMinutes = startTimeMinutes
        this.endTimeMinutes = endTimeMinutes
        break
      case 'stream':
        this.dataType = dataType
        this.episodeId = episodeId
        this.state = event
        this.startTimeMinutes = startTimeMinutes
        this.endTimeMinutes = endTimeMinutes
        break
      case 'favouriteUpdate':
        ;(this.dataType = dataType),
          (this.buttonName = 'epsiodeItem'),
          (this.buttonState = state),
          (this.episodeDownloaded = false),
          (this.episodeFavoriteMarked = state),
          (this.episodeId = episodeId),
          (this.followingPodcast = podcastFollowState),
          (this.itemNumber = 0),
          (this.listName = listName),
          (this.pageName = pageName)
        break
      case 'followUpdate':
        ;(this.dataType = dataType),
          (this.buttonName = 'podcastFollow'),
          (this.buttonState = state),
          (this.followingPodcast = state),
          (this.listName = listName),
          (this.pageName = pageName),
          (this.podcastId = podcastId)
        break
      case 'button':
        ;(this.dataType = dataType),
          (this.buttonName = buttonName),
          (this.buttonState = state),
          (this.episodeId = episodeId)
        break
      default:
        this.dataType = dataType
        this.adId = adId
        this.episodeId = episodeId
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/model/StatisticsData/Data.js